import { render, staticRenderFns } from "./ticket-collector-select.vue?vue&type=template&id=473fac38"
import script from "./ticket-collector-select.vue?vue&type=script&lang=js"
export * from "./ticket-collector-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473fac38')) {
      api.createRecord('473fac38', component.options)
    } else {
      api.reload('473fac38', component.options)
    }
    module.hot.accept("./ticket-collector-select.vue?vue&type=template&id=473fac38", function () {
      api.rerender('473fac38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/selects/ticket-collector-select.vue"
export default component.exports